<ep-user-profile loadCurrentUser="true"></ep-user-profile>
<hr />
<h1>User specific settings</h1>
<div class="row">
    <div class="col-sm-6">
        <h2>Grid settings</h2>
        <div class="row form-group">
            <div class="col-sm-6">
                <label title="Specifies the mode in which all the records are selected">Select all mode</label>
                <select id="selectGridSelectionMode" class="form-control" [(ngModel)]="gridSelectionModeSetting.Value1">
                    <option value="allPages">Selects records on all pages</option>
                    <option value="page">Selects records on current page</option>
                </select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-sm-6">
                <div class="form-group control control-checkbox">
                    <label title="Specifies if a text-search filter should be shown on each column in the grid. This is only applied in Tracking Search">
                        Show filter row for each column in Tracking Search<input class="form-control" type="checkbox" [checked]="gridShowFilterRowSetting.Value1 == 'true'" (change)="gridShowFilterRowSetting.Value1 = $event.target.checked ? 'true' : 'false'" /><i></i>
                    </label>
                </div>
            </div>
        </div>
        <!--<h2>Chart settings</h2>
    <div class="row form-group">
        <div class="col-sm-6">
            <div class="form-group control control-checkbox ">
                <label title="Specifies whether chart refresh time is enabled or not">
                    Enable Chart Refresh time<input class="form-control" type="checkbox" name="chartRefreshTimeEnableDisable" [(ngModel)]="enableChartRefreshTime" /><i></i>
                </label>
            </div>
            <div class="form-group">
                <label title="Specifies chart refresh time in minutes">Chart Refresh time (in seconds)</label>
                <input class="form-control" type="number" min="1" name="chartRefreshTimeMins" [disabled]="!enableChartRefreshTime" [(ngModel)]="chartRefreshtimeSetting.Value2" />
                <div *ngIf="errors[0] && enableChartRefreshTime" class="error">{{errors[0]}}</div>
                <div *ngIf="errors[1] && enableChartRefreshTime" class="error">{{errors[1]}}</div>
            </div>
        </div>
    </div>-->
        <div class="row">
            <div class="col-sm-6">
                <button type="button" class="btn btn-primary" (click)="saveSettings()">Save user specific settings</button>
            </div>
        </div>
    </div>
</div>
